import { Injectable, inject } from '@angular/core';
import { ClaimKey } from '../../models/api/core/claim-key';
import { TaskRequest } from '../../models/api/todo/task-request';
import { Api } from '../api/api.service';
import { BaseService } from '../base.service';
import { Session } from '../session/session.service';

@Injectable({ providedIn: 'root' })
export class TasksService extends BaseService {
  private api = inject(Api);
  private session = inject(Session);

  private claimTasks = new Map<string, any>();

  constructor() {
    super();
    this.dispose.subs = this.session.cacheCleared.subscribe(() => {
      this.claimTasks.clear();
    });
  }

  public async getTasksByClaim(key: ClaimKey) {
    const taskRequest: TaskRequest = {};
    taskRequest.claimUID = key.recordId;
    taskRequest.recordId = key.recordId;
    taskRequest.recordSource = key.recordSource;
    const cacheKey = `tasks-${key.recordSource}-${key.recordId}`;
    if (!this.claimTasks.has(cacheKey)) {
      const result = await this.api.task.getTaskEntry(taskRequest);
      this.claimTasks.set(cacheKey, result);
    }

    return this.claimTasks.get(cacheKey);
  }

  public deleteTasksByClaim(key: ClaimKey) {
    const cacheKey = `tasks-${key.recordSource}-${key.recordId}`;
    this.claimTasks.delete(cacheKey);
  }
}
